import { SkeletonItem } from "@fluentui/react-components";

/**
 * Skeleton for recommended component with carosuel 
 * @returns 
 */
export default function RecommendedCardSkeleton() {
    return (
        <div className="recommended-card-skeleton">
            <div className="recommended-left-skeleton">
                {
                    [0, 1, 2].map((value, i) => (
                        <SkeletonItem className={`recommended-left-skeleton-${i}`} appearance="translucent" size={16} key={i} />
                    ))
                }
            </div>
            <div className="recommended-right-skeleton">
                <SkeletonItem appearance="translucent" shape="circle" size={96} />
            </div>
        </div>
    );
}